<!--
 * @Author: rossdong rossdong@yntengyun.com
 * @Date: 2026-03-17
 * @LastEditors: rossdong rossdong@yntengyun.com
 * @LastEditTime: 2026-04-16 14:48:11
 * @FilePath: /Mobile/src/pages/complaint/views/visual/comps/TipsDialog.vue
 * @Description: Common tips dialog (Vant2 + Vue2) with scrollable content.
 *
-->
<template>
  <van-popup v-model="showModel" class="tips-dialog" :style="popupStyle" :close-on-click-overlay="closeOnClickOverlay"
    @click-overlay="onOverlayClick" get-container="body">
    <div class="tips-dialog__header" v-if="title">
      <div class="tips-dialog__title">{{ title }}</div>
    </div>

    <div class="tips-dialog__body">
      <slot>
        <div class="tips-dialog__content">{{ content }}</div>
      </slot>
    </div>

    <div class="tips-dialog__footer van-hairline--top">
      <van-button class="tips-dialog__button" block @click="onConfirm">
        {{ confirmButtonText }}
      </van-button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'TipsDialog',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    confirmButtonText: {
      type: String,
      default: '关闭'
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showModel: this.value
    }
  },
  computed: {
    popupStyle() {
      return {
        width: '86vw',
        maxWidth: '320px',
        height: 'auto',
        maxHeight: '73vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }
    }
  },
  watch: {
    value(v) {
      this.showModel = v
    },
    showModel(v) {
      if (v !== this.value) this.$emit('input', v)
      if (!v) this.$emit('close')
    }
  },
  methods: {
    onConfirm() {
      this.showModel = false
      this.$emit('confirm')
    },
    onOverlayClick() {
      // keep event for callers
      this.$emit('overlay')
    }
  }
}
</script>

<style lang="less" scoped>
/* Vant popup is rendered in place, scoped styles need deep selectors for Vant internals */
/deep/ .van-overlay {
  background: rgba(0, 0, 0, 0.3);
}

/deep/ .tips-dialog .van-popup {
  width: 86vw !important;
  max-width: 320px !important;
  height: auto !important;
  max-height: 73vh !important;
  border-radius: 8px;
  background: #fff;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.tips-dialog__header {
  padding: 22px 20px 12px;
  flex-shrink: 0;
}

.tips-dialog__title {
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.tips-dialog__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 22px 18px;
}

.tips-dialog__content {
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  color: #666;
  white-space: pre-wrap;
  word-break: break-word;
}

.tips-dialog__footer {
  padding: 0;
  flex-shrink: 0;
}

/deep/ .tips-dialog__button.van-button {
  height: 56px;
  border: none;
  border-radius: 0;
  color: #229f60;
  font-size: 16px;
  font-weight: 600;
}
</style>
